
import {
    HTTP_METHOD_POST,
    REQUEST_URL,
    HTTP_STATUS_OK,
    USER_REQUEST_PASSWORD_RESET
} from "../../global/constants/constants";


export async function requestPasswordReset(email: string) {
    let formdata = new FormData();
    formdata.append("email", email);

    return fetch(REQUEST_URL + USER_REQUEST_PASSWORD_RESET, { method: HTTP_METHOD_POST, body: formdata })
        .then(response => {
            if (response.status === HTTP_STATUS_OK) {
                console.log("Password reset request sent successfully (or 200 returned by server)");
                return 200;
            } else {
                console.log(`Password reset request failed with status: ${response.status}`);
                return response.status;
            }
        })
        .catch(rejected => {
            console.error("Network or fetch error:", rejected);
            return 404;
        });
}